const AUTH_API_BASE_URL = "/oauth";

export const AUTH_API_ENDPOINTS = {
  LOGIN: `${AUTH_API_BASE_URL}/2fa_token`,
  TWO_FACTOR_VERIFICATION: `${AUTH_API_BASE_URL}/verify_2fa_token`,
  RESEND_TWO_FACTOR: `${AUTH_API_BASE_URL}/resend_2fa_token`,
  LOGIN_APPROVAL_STATUS: `${AUTH_API_BASE_URL}/login_approval_status`,
  REGISTER_PHONE: `${AUTH_API_BASE_URL}/register_phone`,
  VERIFY_PHONE_CODE: `${AUTH_API_BASE_URL}/verify_phone_code`,
  REFRESH_TOKEN: `${AUTH_API_BASE_URL}/refresh_token`,
  LOGOUT: `${AUTH_API_BASE_URL}/logout`,
  RESET_PASSWORD: `${AUTH_API_BASE_URL}/reset_password`,
  SET_PASSWORD: `${AUTH_API_BASE_URL}/set_password`,
  RESEND_RESET_LINK: `${AUTH_API_BASE_URL}/resend_reset_link`,
  IMPERSONATE: `${AUTH_API_BASE_URL}/impersonate`,
  EXCHANGE_GRANT_LOGIN: `${AUTH_API_BASE_URL}/exchange_grant_login`,
  GENERATE_CROSS_SCOPE_TOKEN: `${AUTH_API_BASE_URL}/generate_cross_scope_token`,
  EXCHANGE_CROSS_SCOPE_TOKEN: `${AUTH_API_BASE_URL}/exchange_cross_scope_token`,
} as const;
